<template>
  <div class="containerMarcaE">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="mt-5 col-sm-8 col-md-12 mx-auto"
      >
        <div class="grid-container col-md-10 mx-auto">
          <div class="item1">
            <v-text-field
              :label="'*'+$t('mindset.label.titleMindset.title')" 
              :placeholder="$t('mindset.label.titleMindset.title')"
              outlined
              color="secondary"
              required
              :rules="titleRules"
              :counter="40"
              :maxlength="40"
              v-model="dataWelcome.tituloBienvenida"
            >
            </v-text-field>
          </div>

          <div class="item2">
            <v-textarea
              :label="'*'+$t('mindset.label.contentMindset.title')" 
              :placeholder="$t('mindset.label.contentMindset.title')"
              outlined
              color="secondary"
              required
              :rules="contentRules"
              :counter="200"
              :maxlength="200"
              v-model="dataWelcome.cuerpoBienvenida"
            >
            </v-textarea>
          </div>

          <div class="item3">
            <span class="text-welcome">{{ $t('mindset.label.imageMindset.title') }}</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="btn-add-image"
                  fab
                  bottom
                  dark
                  small
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <label for="file-input">
                    <v-icon dark>mdi-plus</v-icon>
                  </label>
                </v-btn>
              </template>
              <span>{{ $t('label.image.text') }}</span>
              <!-- Input de tipo archivo oculto -->
              <input
                type="file"
                @change="onFileChange"
                id="file-input"
                accept="image/*"
                style="display: none"
              />
            </v-tooltip>
          </div>
          <div class="item4 mobile-view">
            <div v-if="dataWelcome.urlImagenBienvenida" class="image-square">
              <!-- Muestra imagen seleccionada -->
              <img
                v-if="
                  allowedImageTypes.includes(
                    dataWelcome.urlImagenBienvenida.type
                  )
                "
                :src="generateImageUrlPreview(dataWelcome.urlImagenBienvenida)"
                alt="Imagen cargada"
              />

              <!-- Muestra imagen si lo trae el servicio -->
              <img
                v-else
                :src="dataWelcome.urlImagenBienvenida"
                alt="Imagen cargada"
              />
            </div>
            <!-- Muestra imagen si NO lo trae el servicio -->
            <div v-else class="image-square">
              <p>{{ $t('label.imagePreview') }}</p>
              <!--<img src="https://beneflex-icons.s3.amazonaws.com/clients/lucasianlabs.svg" alt="Imagen cargada" /> -->
            </div>
            <br />
            <div class="mobile-text">
              <h3>{{ dataWelcome.tituloBienvenida }}</h3>
              <p>{{ dataWelcome.cuerpoBienvenida }}</p>
            </div>
          </div>
        </div>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!valid"
              fab
              fixed
              bottom
              right
              dark
              Large
              color="primary"
              @click="validate()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('button.save') }}</span>
        </v-tooltip>
      </v-form>
    </div>
  </div>
</template>

<script>

import {
  MINDSET_M,
  GET_STATE_LOADING,
  ACTION_PUT_UPDATE_MINDSET,
} from "@/views/mindset/store/types/types.js";

import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';

export default {
    name: "detailMindsetComponent",
    props: {
      mindset: {
        required: true
      },
    },
  data() {
    return {
      valid: true,
      allowedImageTypes: [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg+xml",
      ],
      dataWelcome: {
        idImagenEmpresa: this.mindset.idImagenEmpresa,
        tituloBienvenida: this.mindset.tituloBienvenida,
        cuerpoBienvenida: this.mindset.cuerpoBienvenida,
        urlImagenBienvenida: this.mindset.urlImagenBienvenida,
        estado: this.mindset.estado,
      },
      titleRules: [value => !!value || this.$t('mindset.label.titleMindset.required') ],
      contentRules: [value => !!value || this.$t('mindset.label.contentMindset.required')],
    };
  },
  computed: {
    ...mapGetters({
      loading: `${MINDSET_M}${GET_STATE_LOADING}`,
    }),
  },
  methods: {
    ...mapActions({
      actionUpdateMindset: `${MINDSET_M}${ACTION_PUT_UPDATE_MINDSET}`,
    }),
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.dataWelcome.urlImagenBienvenida = file;
      }
      if (
        !this.allowedImageTypes.includes(
          this.dataWelcome.urlImagenBienvenida.type
        )
      ) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.image.invalid')
        });
      }
    },
    generateImageUrlPreview(file) {
      const preview = URL.createObjectURL(file);
      return preview;
    },
    validate() {
      if (!this.$refs.form.validate()) {
        return Swal.fire({
          icon: "error",
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.invalid.text'),
          confirmButtonColor: '#6E17A5'
        });
      } else {
        if (this.dataWelcome.urlImagenBienvenida == null) {
          Swal.fire({
            icon: "error",
            title: i18n.t('label.invalid.title'),
            text: i18n.t('mindset.label.imageMindset.required'),
          });
        } else {
          // Llamar a la acción de actualizar mindset
          this.actionUpdateMindset(this.dataWelcome)
            .then(() => {
              // Emitir evento para cerrar el diálogo (la lista ya se actualizó en la acción)
              EventBus.$emit('updateMindset-succesfull');
            })
            .catch((error) => {
              // Error: mostrar mensaje y mantener el diálogo abierto SIN cambiar los datos
              console.error('Error al actualizar mindset:', error);
              const errorMessage = error?.data?.payload?.message || 'No se pudo actualizar el mindset';
              Swal.fire({
                icon: "error",
                title: i18n.t('label.invalid.title'),
                text: errorMessage,
                confirmButtonColor: '#6E17A5'
              });
            });
        }
      }
    },
  },
};
</script>

<style lang="css" scoped>
.text-welcome {
  color: #ff7900;
  margin-bottom: 30px;
}

.image-square img {
  max-width: 100%;
  max-height: 100%;
  border: none;
}

.grid-container {
  display: grid;
  gap: 20px;
}

.item4 {
  grid-row: 4/1;
  border: 5px solid #333;
}

.item3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-row: 3/3;
}

.mobile-view {
  width: 300px;
  background: #ff790010;
  border-radius: 15px;
  overflow: hidden;
  max-width: 360px;
  max-height: 550px;
  margin: 0 auto;
  padding: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

.mobile-text,
h3 {
  color: #ff7900;
}

.mobile-text {
  font-family: "Amsi Pro", sans-serif;
  color: #0a0a0a;
  text-align: center;
}

p {
  text-align: center;
}

@media screen and (max-width: 799px) {
  .item1,
  .item3 {
    grid-row: unset;
    margin-top: 10px;
  }
}
</style>

